
export interface PricingPlan {
  id: string;
  name: string;
  price: number;
  interval: string;
  description: string;
  features: string[];
  priceId: string;
  type: string;
  isRecommended?: boolean;
  label?: string;
}

export const pricingPlans: PricingPlan[] = [
  {
    id: "monthly",
    name: "Monthly",
    price: 19.99,
    interval: "month",
    description: "Best for regular strategic planning",
    features: [
      "Unlimited document generation",
      "AI-powered strategic planning",
      "Export to PDF",
      "Email support"
    ],
    priceId: "price_1QhOtZCFL931KD1uLd6J00IU",
    type: "monthly",
    label: "Most Popular"
  },
  {
    id: "team",
    name: "Team",
    price: 99,
    interval: "month",
    description: "Perfect for small teams (up to 5 seats)",
    features: [
      "Everything in Monthly",
      "Team collaboration",
      "Advanced analytics",
      "Priority support"
    ],
    priceId: "price_1RcZDiCFL931KD1uLt5k7pgD",
    type: "team",
    label: "Best for Startups"
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: 399,
    interval: "month",
    description: "For large organizations and consultants (up to 100 seats)",
    features: [
      "Everything in Team",
      "Custom branding",
      "White-label solution",
      "Custom domain",
      "Advanced integrations",
      "Dedicated support",
      "Multi-tenant architecture"
    ],
    priceId: "price_1RcZFaCFL931KD1uSC8jy4Mp",
    type: "enterprise",
    label: "Best for Consultants"
  },
  {
    id: "lifetime",
    name: "Lifetime",
    price: 999,
    interval: "once",
    description: "Limited time offer - pay once, use forever (998 left)",
    features: [
      "Everything in Monthly",
      "Lifetime updates",
      "No recurring fees",
      "Priority feature requests",
      "1-on-1 consulting session",
      "Early access to new features"
    ],
    priceId: "price_1Q8QzHCFL931KD1u55LEohO0",
    type: "lifetime",
    label: "Best Value"
  }
];
